import { createReducer } from '@reduxjs/toolkit';

import getCoMissingParts from '../../../thunks/coilovers/orders/getCoMissingParts';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const getCoMissingPartsReducer = createReducer(initialState, {
  [getCoMissingParts.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCoMissingParts.fulfilled]: (state, { payload: { data } }) => {
    return {
      ...state,
      loading: false,
      data,
    };
  },
  [getCoMissingParts.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCoMissingPartsReducer;
